import { Slider } from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './index.less';

const ProposalSizeByWorkers = ({ value, total, type, showType, isTop, ...props }) => {
  const { t } = useTranslation('proposalRequest');

  const parserBySelection = useCallback((v) => {
    let size = 'proposalRequest.form.partners.sizeOfBusiness.sizes.w100';
    if (v <= 10) {
      size = 'proposalRequest.form.partners.sizeOfBusiness.sizes.w10';
    } else if (v <= 35) {
      size = 'proposalRequest.form.partners.sizeOfBusiness.sizes.w35';
    }
    return t('proposalRequest.form.partners.sizeOfBusiness.mark', {
      value: v,
      size: t(size),
      type: showType && type ? t(`types.${type}`) : ''
    });
  }, [showType, t, type]);

  return (
    <div className={classNames(styles.container, 'w-full pr-8')}>
      <Slider
        marks={{
          11: t('proposalRequest.form.partners.sizeOfBusiness.sizes.w10'),
          35: t('proposalRequest.form.partners.sizeOfBusiness.sizes.w35'),
          100: t('proposalRequest.form.partners.sizeOfBusiness.sizes.w100'),
        }}
        {...props}
        disabled
        defaultValue={value}
        value={value}
        tooltipPlacement={isTop ? 'topLeft' : 'bottomLeft'}
        max={Math.max(total, 100)}
        min={1}
        tipFormatter={parserBySelection}
      />
    </div>
  );
};

ProposalSizeByWorkers.propTypes = {
  type: PropTypes.string,
  isTop: PropTypes.bool,
  showType: PropTypes.bool,
  value: PropTypes.number,
  total: PropTypes.number
};

ProposalSizeByWorkers.defaultProps = {
  showType: true,
  isTop: true,
  value: 0,
  total: 100
};

export default memo(ProposalSizeByWorkers);
